<template>
  <VDialogV3
    id="manufacturer-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localManufacturer"
    :context-menu="editMode ? ManufacturersService.contextMenu : null"
    :on-context-menu-action="onContextMenuAction"
    @submit="onSubmit"
  >
    <section>
      <VInput
        ref="nameInput"
        v-model="localManufacturer.name"
        label="Название производителя"
        layout="vertical"
        :validate-method="validateName"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import Manufacturer            from '@/domains/Manufacturers/Manufacturer';
import ManufacturersService    from '@/domains/Manufacturers/ManufacturersService';

export default defineComponent({
  name: 'ManufacturerCard',

  props: {
    manufacturer: {
      type:    Manufacturer as PropType<Manufacturer | null>,
      default: null,
    },
    id: {
      type:    Number,
      default: null,
    },
  },

  data() {
    return {
      ManufacturersService,
      localManufacturer: null as Manufacturer | null,
    };
  },

  computed: {
    editMode(): boolean {
      return this.localManufacturer?.isExisting ?? false;
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localManufacturer = await ManufacturersService.get(this.id);
      }
      else if (this.manufacturer instanceof Manufacturer) {
        this.localManufacturer = this.$core.utils.cloneDeep(this.manufacturer);
      }
      else {
        this.localManufacturer = new Manufacturer();
      }
    },

    async onSubmit(): Promise<void> {
      let success: boolean;

      if (this.editMode) {
        success = await ManufacturersService.update(this.localManufacturer!);
      }
      else {
        success = await ManufacturersService.add(this.localManufacturer!);
      }

      if (success) {
        this.$core.dialogs.ManufacturerCard.resolve();
      }
    },

    /**
     * Колбэк после действия пункта контекстного меню (refreshAfter !== false).
     * В карточке это «Удалить» — после удаления резолвим диалог: карточка
     * закроется, showCard вернёт true, реестр обновится (позиция исчезнет).
     * Перечитывания черновика здесь нет — карточка закрывается, затирать нечего.
     */
    onContextMenuAction(): void {
      this.$core.dialogs.ManufacturerCard.resolve();
    },

    validateName(value: string): string | null | Promise<string | null> {
      if (typeof value !== 'string' || value.length === 0) { return 'Поле обязательно'; }
      if (value.length > 200) { return 'Максимальная длина поля 200 символов'; }
      if (value === this.manufacturer?.name) { return null; }

      return ManufacturersService.getList({ name: value }).then(list => {
        return list.length > 0 ? 'Ошибка уникальности. Данное название уже существует' : null;
      });
    },
  },
});
</script>
